// Dashboard routes the fork adds (spread into dashboard.routes.js)
import { frontendURL } from 'dashboard/helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import TeamChatHome from './chat/TeamChatHome.vue';
import ChannelView from './chat/ChannelView.vue';
import AiAssistantsPage from './ai/AiAssistantsPage.vue';
import AiAssistantPage from './ai/AiAssistantPage.vue';
import AiSettingsPage from './ai/AiSettingsPage.vue';
import PixtaConnectionPage from './pixta/PixtaConnectionPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/team-chat'),
    name: 'loco_team_chat',
    component: TeamChatHome,
    meta: { permissions: ROLES },
  },
  {
    path: frontendURL('accounts/:accountId/team-chat/:channelId'),
    name: 'loco_team_chat_channel',
    component: ChannelView,
    meta: { permissions: ROLES },
  },
  {
    path: frontendURL('accounts/:accountId/ai'),
    name: 'loco_ai_assistants',
    component: AiAssistantsPage,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/ai/assistants/:assistantId'),
    name: 'loco_ai_assistant',
    component: AiAssistantPage,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/ai/settings'),
    name: 'loco_ai_settings',
    component: AiSettingsPage,
    meta: { permissions: ['administrator'] },
  },
  {
    path: frontendURL('accounts/:accountId/ai/pixta'),
    name: 'loco_pixta_connection',
    component: PixtaConnectionPage,
    meta: { permissions: ['administrator'] },
  },
];
